import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultPRD3012_R01Filter, PRD3012_R01Filter, recalculateDetailListWithTransport, usePRD3012_R01Store } from './Store_PRD3012_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deletePRD3012_R01, deletePRD3012_R01Inspect, downloadExcel_PRD3012_R01, getPdfBlob_PRD3012_R01, getPRD3012_R01AllCount, getPRD3012_R01InspectList, getPRD3012_R01List, getPRD3012_R01ProductResultList, patchPRD3012_R01, postPRD3012_R01, postPRD3012_R01Inspect, postPRD3012_R01StockLot, getPRD3012_R01DetailList, getPRD3012_R01DetailStockList, getPRD3012_R01One, getPRD3012_R01StockLot, createPRD3012_R01LotNo } from "./Api_PRD3012_R01";
import { defaultPRD3012_R01LotDto, defaultPRD3012_R01HeaderDto, defaultPRD3012_R01InspectDto, PRD3012_R01LotDto, PRD3012_R01Dto, PRD3012_R01HeaderDto, PRD3012_R01InspectDto, PRD3012_R01ProductResultDto, defaultPRD3012_R01DetailDto, PRD3012_R01DetailDto, PRD3012_R01WorkTimeProcessType } from './Dto_PRD3012_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	PRD3012_R01_HEADERROW_VALIDATE,
	PRD3012_R01_INSPECTROW_VALIDATE,
	PRD3012_R01_LOTROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useWarehouseValidate } from 'src/utils/warehouse/WarehouseValidateContext';
import { getDefaultLabelPrintAuto } from 'src/utils/label/labelPrintAutoProgramUtil';
import qz from 'qz-tray';
import { formatDate, toLocalDateTime, validateString } from 'src/utils/string/stringUtil';
import { validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { defaultWorkTimeResetDate } from 'src/components/common/common';
import { isUnsetWorkDateTime } from 'src/utils/date/dateUtils';
import { AxiosError } from 'axios';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { getProductResultPopupList } from 'src/apis/productResultApi';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import useUserStore from 'src/store/useUserStore';
import { LabelPrintData } from 'src/apis/labelApi';
import { useQzPrint } from 'src/hooks/useQzPrint';
import { PRD3012_R01_extractUnprintedLabelData } from './labelDataBuilder_PRD3012_R01';
import { aggregateInspectListByBadCase, validateEditBadQtyAgainstInspectList } from './inspectBadQtyUtil_PRD3012_R01';

interface Props {
	gridRef: React.RefObject<AgGridReact<PRD3012_R01HeaderDto> | null>;
	lotGridRef: React.RefObject<AgGridReact<PRD3012_R01LotDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<PRD3012_R01DetailDto> | null>;
	inspectGridRef: React.RefObject<AgGridReact<PRD3012_R01InspectDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_PRD3012_R01 = (props: Props) => {

	const {
		gridRef, lotGridRef, detailGridRef, inspectGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { faultyValueList, itemStatusList, compCdList, wmsCdList, employeeCdList, workPlaceList, warehouseCdList, itemCdMap, programList } = useCommonCodeStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { validateWorkplaceWarehouse } = useWarehouseValidate();

	
	const {
		PRD3012_R01Filter, setPRD3012_R01Filter,
		PRD3012_R01PastFilter, setPRD3012_R01PastFilter,
		PRD3012_R01List, setPRD3012_R01List,
		editPRD3012_R01, setEditPRD3012_R01,
		selectedPRD3012_R01, setSelectedPRD3012_R01,
		deletedPRD3012_R01LotList, setDeletedPRD3012_R01LotList, addDeletedPRD3012_R01LotList, removeDeletedPRD3012_R01LotList,
		selectedPRD3012_R01LotList, setSelectedPRD3012_R01LotList, addSelectedPRD3012_R01LotList, removeSelectedPRD3012_R01LotList,
		PRD3012_R01LotList, setPRD3012_R01LotList, insertPRD3012_R01LotList,
		originalPRD3012_R01LotList, setOriginalPRD3012_R01LotList,
		deletedPRD3012_R01DetailList, setDeletedPRD3012_R01DetailList, addDeletedPRD3012_R01DetailList, removeDeletedPRD3012_R01DetailList, 
		selectedPRD3012_R01DetailList, setSelectedPRD3012_R01DetailList, addSelectedPRD3012_R01DetailList, removeSelectedPRD3012_R01DetailList,
		PRD3012_R01DetailList, setPRD3012_R01DetailList, insertPRD3012_R01DetailList,
		originalPRD3012_R01DetailList, setOriginalPRD3012_R01DetailList,
		PRD3012_R01InspectList, setPRD3012_R01InspectList, insertPRD3012_R01InspectList, removePRD3012_R01InspectList,
		deletedPRD3012_R01InspectList, setDeletedPRD3012_R01InspectList, addDeletedPRD3012_R01InspectList, removeDeletedPRD3012_R01InspectList,
		selectedPRD3012_R01InspectList, setSelectedPRD3012_R01InspectList, addSelectedPRD3012_R01InspectList, removeSelectedPRD3012_R01InspectList,
		originalPRD3012_R01InspectList, setOriginalPRD3012_R01InspectList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		notProductResult, setNotProductResult,
		initPRD3012_R01LotData,
		modalVisible, setModalVisible,
		workTimeModalVisible, setWorkTimeModalVisible,
		workTimeModalType, setWorkTimeModalType,
		initData,
		warehouseCdListToUseList, outWarehouseCdListToUseList, badWarehouseCdListToUseList,
		setScrollTop, setDetailScrollTop, setLotScrollTop, setInspectScrollTop,
	} = usePRD3012_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { company } = useUserStore();
	const { printBulkLabel, printPdfFromBlob } = useQzPrint();

	const defaultLabelPrintAuto = useMemo(() => getDefaultLabelPrintAuto(programList), [programList]);

	const handleFetchProductResultRef = useRef<(() => Promise<void>) | null>(null);
	const isFetchingProductResultRef = useRef(false);

	const productResultInfoHandleFocusId = 'inputProductResultNo_search';

	useFetchActionbarAuth("PRD3012_R01");

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'productResultNo',
			category: '생산실적',
			focusId: productResultInfoHandleFocusId,
			responseMapping: {
				productResultNo: 'productResultNo',
				productOrderNo: 'productOrderNo',
			},
			searchFunction: async (code: string) => {
				const productResultResponse = await getProductResultPopupList(code, {
				});
				return productResultResponse.data.data.find(value => value.productResultNo === code);
			},
			extraFilter: () => ({
				productOrderNo: editPRD3012_R01?.productOrderNo || '',
			}),
			onAfterConfirm: () => {
				void handleFetchProductResultRef.current?.();
			},
		},
	];

	const handlePrintClick = useCallback(async () => {
		const printTarget = selectedPRD3012_R01 ?? editPRD3012_R01;
		if (!printTarget?.productResultNo) {
			showWarning("출력할 생산실적번호를 선택하세요.");
			setMessage("출력할 생산실적번호를 선택하세요.");
			return;
		}
		setLoadingSpinner(true);
		try {
			const blob = await getPdfBlob_PRD3012_R01(printTarget.productResultNo);
			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, "report1");
				if (ok) {
					showSuccess("PDF 출력을 완료하였습니다.");
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, "_blank");
				setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
			}
		} catch (error) {
			setMessage("PDF 출력 중 오류가 발생했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedPRD3012_R01, editPRD3012_R01, printPdfFromBlob, setLoadingSpinner, setMessage]);

	const handleExcelClick = useCallback(async () => {
		const excelTarget = selectedPRD3012_R01 ?? editPRD3012_R01;
		if (!excelTarget?.productResultNo) {
			showWarning("선택된 생산실적내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_PRD3012_R01('', excelTarget.productResultNo, PRD3012_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '생산실적 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedPRD3012_R01, editPRD3012_R01, PRD3012_R01List, setLoadingSpinner]);

	const getParams = (filter: PRD3012_R01Filter) => {
		const params: Partial<PRD3012_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			compCd: filter.compCd || undefined,
			compNm: filter.compNm || undefined,
			workplaceCd: filter.workplaceCd || undefined,
			itemCd: filter.itemCd || undefined,
			itemNm: filter.itemNm || undefined,
			workEmp: filter.workEmp || undefined,
			workEmpNm: filter.workEmpNm || undefined,
			labelPrintAuto: filter.labelPrintAuto || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getPRD3012_R01AllCount(getParams(PRD3012_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [PRD3012_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLotScrollTop(null);
		setInspectScrollTop(null);
		setLoadingSpinner(true);

		const responseData = (await getPRD3012_R01List(
			'',
			getParams(PRD3012_R01Filter),
			PRD3012_R01List.length ?? 0
		));

		let newList = [...responseData.data.data] as PRD3012_R01HeaderDto[];
		newList = newList.map((row) => ({
			...row,
			orderQty: Math.max(0, Number(row.orderQty) || 0),
		}));
		setPRD3012_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedPRD3012_R01,
				() => true,
			);
			setPRD3012_R01PastFilter(PRD3012_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		} else {
			showWarning('데이터가 없습니다.');
			setSelectedPRD3012_R01(undefined);
			setPRD3012_R01List([]);
			setPRD3012_R01LotList([]);
			setDeletedPRD3012_R01LotList([]);
			setSelectedPRD3012_R01LotList([]);
			setOriginalPRD3012_R01LotList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [
		PRD3012_R01Filter, PRD3012_R01List, setPRD3012_R01List, setPRD3012_R01PastFilter,
		setSelectedPRD3012_R01, renewalAllCount, setScrollTop, setDetailScrollTop,
		setLotScrollTop, setInspectScrollTop, setLoadingSpinner, setMessage,
	]);

	const resolveQtyAfterLotIssue = (
		prevEdit: PRD3012_R01HeaderDto,
		responseOrderHeader: PRD3012_R01HeaderDto,
		issuedQty: number,
	) => {
		const prevResultQty = Number(prevEdit.resultQty) || 0;
		const responseResultQty = Number(responseOrderHeader.resultQty) || 0;
		const newResultQty = responseResultQty > prevResultQty
			? responseResultQty
			: prevResultQty + issuedQty;
		const newOrderQty = Math.max(0, (Number(prevEdit.orderQty) || 0) - issuedQty);
		return {
			resultQty: newResultQty,
			productQty: newResultQty,
			orderQty: newOrderQty,
		};
	};

	const fetchOne = useCallback(async (productOrderNoArg?: string) => {
		const state = usePRD3012_R01Store.getState();
		const productOrderNo = productOrderNoArg
			|| state.selectedPRD3012_R01?.productOrderNo
			|| state.editPRD3012_R01?.productOrderNo
			|| '';

		if (!validateString(productOrderNo)) {
			showWarning('조회할 작업지시번호를 선택하세요.');
			return;
		}
		setLoadingSpinner(true);

		const response = await getPRD3012_R01One(productOrderNo);
		
		if(!response.data.data) {
			showWarning('조회된 데이터가 없습니다.');
			setLoadingSpinner(false);
			return;
		}

		const workPlaceInfo = workPlaceList.find(value => value.workplaceCd === response.data.data?.workplaceCd);

		let logicCenter = wmsCdList.filter(value => value.minorCd === workPlaceInfo?.logicCenter)[0].minorCd;
		let defaultInWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& (value.productYn === 'Y' || value.manufactYn === 'Y' )
		);
		let defaultOutWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& (value.materialYn === 'Y' || value.manufactYn === 'Y' )
		);
		let defaultBadWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& value.badYn === 'Y'
		);
		let inWarehouseCd = defaultInWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.inWarehouse));
		let outWarehouseCd = defaultOutWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.outWarehouse));
		let badWarehouseCd = defaultBadWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.badWarehouse));

		// console.log('작업지시정보의 logicCenter :', logicCenter);
		// console.log('작업지시정보의 inWarehouseCd :', inWarehouseCd, ' > ', '작업지시정보의 outWarehouseCd :', outWarehouseCd);

		response.data.data.logicCenter = logicCenter || wmsCdList[0]?.minorCd || '';
		response.data.data.warehouseCd = validateString(response.data.data.warehouseCd) ? response.data.data.warehouseCd : (inWarehouseCd[0]?.warehouseCd ?? '');
		response.data.data.outWarehouseCd = validateString(response.data.data.outWarehouseCd) ? response.data.data.outWarehouseCd : (outWarehouseCd[0]?.warehouseCd ?? '');
		response.data.data.badWarehouseCd = validateString(response.data.data.badWarehouseCd) ? response.data.data.badWarehouseCd : (badWarehouseCd[0]?.warehouseCd ?? '');

		// 작업지시 재조회 시 이전 실적/작업시간 등 잔여값 초기화
		const resetWorkTime = new Date(defaultWorkTimeResetDate);
		const resultQty = Number(response.data.data.resultQty) || 0;
		const fullOrderQty = Number(response.data.data.orderQty) || 0;
		const mappedHeader: PRD3012_R01HeaderDto = {
			...response.data.data,
			productDt: formatDate(new Date()),
			resultQty,
			productQty: resultQty,
			// API 총지시량 → 화면 잔량(지시 - 실적), 음수면 0
			orderQty: Math.max(0, fullOrderQty - resultQty),
			productResultNo: '',
			pendingLotQty: 0,
			badQty: 0,
			acceptQty: 0,
			plcCount: 0,
			workStartDt: toLocalDateTime(resetWorkTime),
			workEndDt: toLocalDateTime(resetWorkTime),
			timeParam: toLocalDateTime(new Date()),
		};
		setEditPRD3012_R01(mappedHeader);
		setNotProductResult(true);

		setLoadingSpinner(false);
		return mappedHeader as PRD3012_R01HeaderDto;
	}, [setEditPRD3012_R01, setLoadingSpinner, setNotProductResult, workPlaceList, wmsCdList, warehouseCdList]);

	const fetchDetailList = useCallback(async (
		itemCd: string,
		productQty: number,
		badQty: number,
		outWarehouseCd: string,
		logicCenter: string,
		workPlaceCd: string,
	) => {
		try {
			const productOrderNo = usePRD3012_R01Store.getState().editPRD3012_R01?.productOrderNo || '';
			const response = await getPRD3012_R01DetailList(
				productOrderNo, itemCd, productQty, badQty, outWarehouseCd, logicCenter, workPlaceCd,
			);

			if (response.data && response.data.successFlag === false) {
				setPRD3012_R01DetailList([]);
				return;
			}

			const responseData = response.data.data;
			if (responseData && responseData.length > 0) {
				const updatedDetailList = responseData.map((value, idx) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
					lotQty: value.lotQty ?? 0,
					transportQty: 0,
					transportedQty: 0,
				}));
				setPRD3012_R01DetailList(updatedDetailList);
				setOriginalPRD3012_R01DetailList(responseData);
				detailGridRef.current?.api.ensureIndexVisible(0, 'top');
				setTimeout(() => setMessage(""), 5000);
			} else {
				setPRD3012_R01DetailList([]);
			}
		} catch (error) {
			console.error(error);
			setPRD3012_R01DetailList([]);
		}
	}, [setPRD3012_R01DetailList, setOriginalPRD3012_R01DetailList, setMessage]);
	

	const defaultPRD3012_R01HeaderRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3012_R01_HEADERROW_VALIDATE, {
				compCdList,
				itemStatusList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultPRD3012_R01HeaderDto, inserted: true };
		}

		const warehouseResult = validateWorkplaceWarehouse({
			mode: 'workplace',
			workPlaceList,
			warehouseCdList,
			wmsCdList,
			workplaceCd: workPlaceList[0]?.workplaceCd ?? '',
		});
		if (!warehouseResult.valid || warehouseResult.mode !== 'workplace') {
			return { ...defaultPRD3012_R01HeaderDto, inserted: true };
		}
		const { logicCenter: warehouseLogicCenter, inWarehouseCd, outWarehouseCd, badWarehouseCd } = warehouseResult;

		return {
			...defaultPRD3012_R01HeaderDto,
			compCd: compCdList[0].compCd,
			workplaceCd: workPlaceList[0].workplaceCd,
			logicCenter: warehouseLogicCenter,
			warehouseCd: inWarehouseCd[0].warehouseCd,
			outWarehouseCd: outWarehouseCd[0].warehouseCd,
			badWarehouseCd: badWarehouseCd[0].warehouseCd,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [
		compCdList, workPlaceList, itemStatusList, wmsCdList, warehouseCdList,
		validateCommonCodeLists, validateWorkplaceWarehouse,
	]);

	const defaultPRD3012_R01LotRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3012_R01_LOTROW_VALIDATE, { itemStatusList }),
		);

		if (!commonResult.valid) {
			return {
				...defaultPRD3012_R01LotDto,
				inserted: true,
			};
		}

		return {
			...defaultPRD3012_R01LotDto,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [itemStatusList, validateCommonCodeLists]);

	const defaultPRD3012_R01DetailRow = useCallback(() => ({
		...defaultPRD3012_R01DetailDto,
		inserted: true,
	}), [defaultPRD3012_R01DetailDto]);

	const defaultPRD3012_R01InspectRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3012_R01_INSPECTROW_VALIDATE, { faultyValueList }),
		);

		if (!commonResult.valid) {
			return {
				...defaultPRD3012_R01InspectDto,
				inserted: true,
			};
		}

		return {
			...defaultPRD3012_R01InspectDto,
			badCase: faultyValueList[0].minorCd,
			inserted: true,
		};
	}, [faultyValueList, validateCommonCodeLists]);

	const resetToWorkOrderInitialState = useCallback(async (): Promise<boolean> => {
		if (!validateString(editPRD3012_R01?.productOrderNo || '')) {
			return false;
		}

		setPRD3012_R01LotList([]);
		setPRD3012_R01DetailList([]);
		setPRD3012_R01InspectList([]);
		setDeletedPRD3012_R01LotList([]);
		setSelectedPRD3012_R01LotList([]);
		setOriginalPRD3012_R01LotList([]);
		setDeletedPRD3012_R01InspectList([]);
		setSelectedPRD3012_R01InspectList([]);
		setOriginalPRD3012_R01InspectList([]);

		const headerData = await fetchOne();
		if (!headerData) {
			return false;
		}

		await fetchDetailList(
			headerData.itemCd || '',
			0,
			0,
			headerData.outWarehouseCd,
			headerData.logicCenter,
			headerData.workplaceCd,
		);

		initPRD3012_R01LotData();
		setPRD3012_R01InspectList([]);
		insertPRD3012_R01InspectList([defaultPRD3012_R01InspectRow()]);

		const latestEdit = usePRD3012_R01Store.getState().editPRD3012_R01;
		if (latestEdit) {
			const resetWorkTime = new Date(defaultWorkTimeResetDate);
			setEditPRD3012_R01({
				...latestEdit,
				productResultNo: '',
				productDt: formatDate(new Date()),
				pendingLotQty: 0,
				badQty: 0,
				workStartDt: toLocalDateTime(resetWorkTime),
				workEndDt: toLocalDateTime(resetWorkTime),
			});
		}
		setNotProductResult(true);
		return true;
	}, [
		defaultPRD3012_R01InspectRow,
		editPRD3012_R01?.productOrderNo,
		fetchDetailList,
		fetchOne,
		initPRD3012_R01LotData,
		insertPRD3012_R01InspectList,
		setDeletedPRD3012_R01InspectList,
		setDeletedPRD3012_R01LotList,
		setEditPRD3012_R01,
		setPRD3012_R01DetailList,
		setPRD3012_R01InspectList,
		setPRD3012_R01LotList,
		setNotProductResult,
		setOriginalPRD3012_R01InspectList,
		setOriginalPRD3012_R01LotList,
		setSelectedPRD3012_R01InspectList,
		setSelectedPRD3012_R01LotList,
	]);
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedPRD3012_R01LotList();
		removeSelectedPRD3012_R01LotList();
		setEditPRD3012_R01(defaultPRD3012_R01HeaderRow());
		setPRD3012_R01Filter({ ...PRD3012_R01Filter, labelPrintAuto: defaultLabelPrintAuto });
	}, [company, defaultLabelPrintAuto, defaultPRD3012_R01HeaderRow, initData, PRD3012_R01Filter, removeDeletedPRD3012_R01LotList, removeSelectedPRD3012_R01LotList, setEditPRD3012_R01, setPRD3012_R01Filter]);

	const handleDeleteClick = useCallback(() => {
		if (deletedPRD3012_R01InspectList.length > 0) {
			removeDeletedPRD3012_R01InspectList(deletedPRD3012_R01InspectList);
			removeSelectedPRD3012_R01InspectList();
			setPRD3012_R01InspectList([...PRD3012_R01InspectList]);
		} else if (selectedPRD3012_R01InspectList.length > 0) {
			addDeletedPRD3012_R01InspectList(selectedPRD3012_R01InspectList);
			removeSelectedPRD3012_R01InspectList(selectedPRD3012_R01InspectList);
		}
	}, [
		selectedPRD3012_R01InspectList, deletedPRD3012_R01InspectList, setPRD3012_R01InspectList, PRD3012_R01InspectList,
		removeDeletedPRD3012_R01InspectList, removeSelectedPRD3012_R01InspectList, addDeletedPRD3012_R01InspectList,
	]);
	
	const handleCreateClick = () => {
		setSelectedPRD3012_R01(undefined);
		setEditPRD3012_R01(defaultPRD3012_R01HeaderRow());

		setPRD3012_R01LotList([]);
		setDeletedPRD3012_R01LotList([]);
		setSelectedPRD3012_R01LotList([]);

		setPRD3012_R01InspectList([defaultPRD3012_R01InspectRow()]);
		setDeletedPRD3012_R01InspectList([]);
		setSelectedPRD3012_R01InspectList([]);
		setOriginalPRD3012_R01InspectList([]);
	}

	/** 생산일자 — 유효하지 않으면 당일 */
	const resolvePRD3012_R01ProductDt = (
		header?: Pick<PRD3012_R01HeaderDto, 'productDt'> | null,
		fallback?: string,
	): string => {
		if (header?.productDt) {
			const parsed = new Date(header.productDt);
			if (!Number.isNaN(parsed.getTime())) {
				return formatDate(parsed);
			}
		}
		return fallback ?? formatDate(new Date());
	};

	const getProductResultHeaderDto = (header: PRD3012_R01HeaderDto) => {
		const productDt = resolvePRD3012_R01ProductDt(header);
		return {
			...header,
			productDt,
			workStartDt: header.workStartDt ?? toLocalDateTime(new Date(productDt)),
			workEndDt: header.workEndDt,
			kpiYn: 'N',
			inspectQty: 0,
			inspectYn: 'N',
			productEmp: header.productEmp || header.orderEmp,
			productEmpNm: header.productEmpNm || header.orderEmpNm,
			badWarehouseCd: header.badWarehouseCd,
			outWarehouseCd: header.outWarehouseCd,
		} as PRD3012_R01ProductResultDto;
	}

	const refreshInspectListFromServer = useCallback(async (productResultNo: string) => {
		const inspectResponse = await getPRD3012_R01InspectList(productResultNo);
		const inspectList = inspectResponse.data.data ?? [];

		setDeletedPRD3012_R01InspectList([]);
		setSelectedPRD3012_R01InspectList([]);

		if (inspectList.length > 0) {
			setPRD3012_R01InspectList([]);
			insertPRD3012_R01InspectList(inspectList);
			setOriginalPRD3012_R01InspectList(inspectList);
		} else {
			setPRD3012_R01InspectList([defaultPRD3012_R01InspectRow()]);
			setOriginalPRD3012_R01InspectList([]);
		}

		// ResultInfo 생산불량수량 — inspect 목록 badQty 합계로 반영
		const { totalQty } = aggregateInspectListByBadCase(inspectList);
		const latestEdit = usePRD3012_R01Store.getState().editPRD3012_R01;
		if (latestEdit) {
			setEditPRD3012_R01({ ...latestEdit, badQty: totalQty });
		}

	}, [
		defaultPRD3012_R01InspectRow,
		insertPRD3012_R01InspectList,
		setDeletedPRD3012_R01InspectList,
		setEditPRD3012_R01,
		setPRD3012_R01InspectList,
		setOriginalPRD3012_R01InspectList,
		setSelectedPRD3012_R01InspectList,
	]);

	const validateInspectModalData = useCallback(() => {
		if (!editPRD3012_R01 || !validateString(editPRD3012_R01.productResultNo)) {
			showWarning('생산실적코드를 입력하세요.');
			return false;
		}

		const deletedInspectListToNumber = deletedPRD3012_R01InspectList.map(value => Number(value));
		const badQtyValidation = validateEditBadQtyAgainstInspectList(
			editPRD3012_R01.badQty || 0,
			PRD3012_R01InspectList,
			deletedInspectListToNumber,
		);
		if (!badQtyValidation.valid) {
			showWarning(badQtyValidation.message!);
			return false;
		}

		const activeInspectList = PRD3012_R01InspectList.filter(inspect =>
			!deletedInspectListToNumber.includes(inspect.valueIndex),
		);
		const badCases = activeInspectList.map(detail => detail.badCase).filter(badCase => badCase);
		const duplicates = badCases.filter((badCase, index) => badCases.indexOf(badCase) !== index);
		if (duplicates.length > 0) {
			const badCaseNames = duplicates.map(badCase => faultyValueList.find(value => value.minorCd === badCase)?.codeNm);
			showWarning('중복된 불량사유가 있습니다.\n불량사유: ' + badCaseNames.join(', '));
			return false;
		}

		return true;
	}, [
		deletedPRD3012_R01InspectList,
		editPRD3012_R01,
		faultyValueList,
		PRD3012_R01InspectList,
	]);

	const handleInspectConfirmClick = useCallback(async () => {
		if (!validateInspectModalData()) return;

		const insertInspectList = PRD3012_R01InspectList.filter(row =>
			row.inserted === true && validateString(row.badCase),
		);
		if (insertInspectList.length === 0) {
			showWarning('등록할 불량내역이 없습니다. (행+ 버튼으로 추가한 행만 등록됩니다.)');
			return;
		}

		setLoadingSpinner(true);
		try {
			const response = await postPRD3012_R01Inspect({
				productOrderHeaderDto: editPRD3012_R01!,
				productResultHeaderDto: {
					...getProductResultHeaderDto(editPRD3012_R01!),
					badQty: editPRD3012_R01!.badQty ?? 0,
				},
				wmsStockLotDtoList: [],
				bomDtoList: [],
				prdInspectResultDtoList: insertInspectList,
			});

			if (!response.data?.successFlag) {
				showWarning('불량내역 등록에 실패하였습니다.');
				return;
			}

			const responseData = response.data.data;
			setEditPRD3012_R01({
				...editPRD3012_R01!,
				badQty: responseData.productResultHeaderDto?.badQty ?? editPRD3012_R01!.badQty ?? 0,
			});

			await refreshInspectListFromServer(editPRD3012_R01!.productResultNo);
			showSuccess('불량내역 등록이 완료되었습니다.');
			setMessage('불량내역 등록이 완료되었습니다.');
			setModalVisible(false);
		} catch (error) {
			console.error('불량내역 등록 중 오류가 발생했습니다.:', error);
			const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
			showWarning(serverMessage || '불량내역 등록 중 오류가 발생하였습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [
		editPRD3012_R01,
		PRD3012_R01InspectList,
		refreshInspectListFromServer,
		setEditPRD3012_R01,
		setLoadingSpinner,
		setMessage,
		setModalVisible,
		validateInspectModalData,
	]);

	const handleInspectDeleteClick = useCallback(async () => {
		if (deletedPRD3012_R01InspectList.length > 0) {
			removeDeletedPRD3012_R01InspectList(deletedPRD3012_R01InspectList);
			removeSelectedPRD3012_R01InspectList();
			setPRD3012_R01InspectList([...PRD3012_R01InspectList]);
			return;
		}

		if (selectedPRD3012_R01InspectList.length === 0) {
			showWarning('삭제할 불량내역을 선택하세요.');
			return;
		}

		const selectedRows = PRD3012_R01InspectList.filter(row =>
			selectedPRD3012_R01InspectList.includes(String(row.valueIndex)),
		);
		const serverDeleteRows = selectedRows.filter(row => validateString(row.inspectNo));
		const localInsertRows = selectedRows.filter(row => row.inserted === true && !validateString(row.inspectNo));

		if (serverDeleteRows.length === 0 && localInsertRows.length === 0) {
			showWarning('삭제할 불량내역이 없습니다.');
			return;
		}

		setLoadingSpinner(true);
		try {
			if (serverDeleteRows.length > 0) {
				if (!editPRD3012_R01 || !validateString(editPRD3012_R01.productResultNo)) {
					showWarning('생산실적코드를 입력하세요.');
					return;
				}

				const deleteResponse = await deletePRD3012_R01Inspect({
					productOrderHeaderDto: editPRD3012_R01,
					productResultHeaderDto: getProductResultHeaderDto(editPRD3012_R01),
					wmsStockLotDtoList: [],
					bomDtoList: [],
					prdInspectResultDtoList: serverDeleteRows,
				});

				if (!deleteResponse.data?.successFlag) {
					showWarning('불량내역 삭제에 실패하였습니다.');
					return;
				}

				await refreshInspectListFromServer(editPRD3012_R01.productResultNo);
				showSuccess('불량내역 삭제가 완료되었습니다.');
				setMessage('불량내역 삭제가 완료되었습니다.');
			}

			localInsertRows.forEach(row => {
				removePRD3012_R01InspectList(row.valueIndex);
			});
			removeSelectedPRD3012_R01InspectList(selectedPRD3012_R01InspectList);
		} catch (error) {
			console.error('불량내역 삭제 중 오류가 발생했습니다.:', error);
			const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
			showWarning(serverMessage || '불량내역 삭제 중 오류가 발생하였습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [
		deletedPRD3012_R01InspectList,
		editPRD3012_R01,
		PRD3012_R01InspectList,
		refreshInspectListFromServer,
		removeDeletedPRD3012_R01InspectList,
		removePRD3012_R01InspectList,
		removeSelectedPRD3012_R01InspectList,
		selectedPRD3012_R01InspectList,
		setPRD3012_R01InspectList,
		setLoadingSpinner,
		setMessage,
	]);

	const validateInsertData = (
		header: PRD3012_R01HeaderDto,
		lotList: PRD3012_R01LotDto[],
		detailList: PRD3012_R01DetailDto[],
		inspectList: PRD3012_R01InspectDto[],
	) => {

		let warningMessage = '(지시No 조회필요)';
		
		if (!validateString(header.productOrderNo)) {
			showWarning('지시No를 입력해주세요.'); return false;
		}
		if (!validateString(header.compCd)) {
			showWarning('지시정보가 없습니다. 사업장을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.workplaceCd)) {
			showWarning('공정명을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.itemCd)) {
			showWarning('품목코드를 입력해주세요.' + warningMessage); return false;
		}
		if (!itemCdMap.has(header.itemCd)) {
			showWarning('품목코드가 존재하지 않습니다.' + warningMessage); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('입고물류를 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('입고창고를 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.orderEmp)) {
			showWarning('담당자를 입력해주세요.' + warningMessage); return false;
		}
		if (!validateEmployeeCd(header.orderEmp, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (Number(header.productQty) + Number(header.badQty) > Number(header.orderQty)) {
			if (header.workStartDt == null || header.workEndDt == null) {
				showWarning('생산양품량과 불량수량의 합이 지시잔량을 초과하는 경우, 작업 시작시간과 종료시간을 등록해주세요.');
				return false;
			}
		}
		// if (header.productQty > header.orderQty) {
		// 	showWarning('양품수량(lot 작업지시량)은 생산실적수량보다 클 수 없습니다.'); return false;
		// }

		let activeLotList: PRD3012_R01LotDto[] = [];
 
		// Lot 항목 검증
		if (lotList.length > 0) {
			const deletedLotListToNumber = deletedPRD3012_R01LotList.map(value => Number(value));
			activeLotList = lotList.filter(detail => 
				!deletedLotListToNumber.includes(detail.valueIndex)
			);

			// 1. lotNo가 있는 항목들만 골라냅니다.
			const lotNos = activeLotList.map(detail => detail.lotNo).filter(lotNo => lotNo); // lotNo 가져오기
			const duplicates = lotNos.filter((lot, index) => lotNos.indexOf(lot) !== index);	// lotNo 중복 제거
			
			if (duplicates.length > 0) {
				showWarning("중복된 LOT No가 있습니다.\nLOT No: " + duplicates[0]);
				return false;
			}
		}

		const validateLotList = lotList.filter(detail => 
			detail.inserted === true && detail.lotQty > 0
		);
			
		//lot 입력행이나 자재출고 수정행이 없으면 반려
		if(validateLotList.length === 0) {
			showWarning('Lot 입력행을 입력해주세요. (최소 1개 이상 입력)'); return false;
		}


		//자재출고 검증
		if (detailList.length > 0) {
			for (const detail of detailList) {
				if (detail.transportQty > detail.lotQty) {
					showWarning(`${detail.childItemcd} 품목의 출고량은 재고량보다 클 수 없습니다.`); return false;
				}
			}

			//childItemcd 기준으로 각 요소들을 분배해서 각 품목코드에 대한 출고량을 계산, 소요량과 비교해서 출고량이 소요량보다 클 수 없다
			// 현재는 수정해서 출고량이 소요량보다 높아도 되는데 롤백할 가능성이 있어서 코드를 보관함
			//
			const childItemcdList = detailList.map(detail => detail.childItemcd).filter(childItemcd => childItemcd);
			const uniqueChildItemcdList = Array.from(new Set(childItemcdList));
			for (const childItemcd of uniqueChildItemcdList) {
				const childItemcdDetailList = detailList.filter(detail => detail.childItemcd === childItemcd);
				const childItemcdTransportQty = childItemcdDetailList.reduce((sum, detail) => sum + detail.transportQty, 0);
				// if (childItemcdTransportQty > childItemcdDetailList[0].bomUsingQty) {
				// 	showWarning(`${childItemcd} 품목의 출고량은 소요량보다 클수 없습니다. `); return false;
				// }
			}
		}
		//불량사유 검증
		if (inspectList.length > 0) {
			const deletedInspectListToNumber = deletedPRD3012_R01InspectList.map(value => Number(value));
			const activeInspectList = inspectList.filter(inspect => 
				!deletedInspectListToNumber.includes(inspect.valueIndex)
			);

			// 1. badCase가 있는 항목들만 골라냅니다.
			const badCases = activeInspectList.map(detail => detail.badCase).filter(badCase => badCase);	// badCase 가져오기
			const duplicates = badCases.filter((badCase, index) => badCases.indexOf(badCase) !== index);	// badCase 중복 제거

			//불량사유 코드명 추출
			const badCaseNames = duplicates.map(badCase => faultyValueList.find(value => value.minorCd === badCase)?.codeNm);
			
			if (duplicates.length > 0) {
				showWarning("중복된 불량사유가 있습니다.\n불량사유: " + badCaseNames.join(', '));
				return false;
			}
		}
		
		return true;
	}
	
	const assignLotNoToLists = useCallback(async (currentLotList: PRD3012_R01LotDto[]) => {
		const deletedPRD3012_R01LotList_Number = deletedPRD3012_R01LotList.map(value => Number(value));

		const activeList = currentLotList.filter(lot => !deletedPRD3012_R01LotList_Number.includes(lot.valueIndex));
		const newLotList = await Promise.all(activeList.map(async (lot) => {
			let generatedLotNo = lot.lotNo;

			// API 호출하여 LotNo 생성
			const res = await createPRD3012_R01LotNo();
			if (res.data && res.data.successFlag) {
				generatedLotNo = res.data.data;
			}

			// 업데이트된 LotNo를 가진 새 객체 반환
			return {
				...lot,
				lotNo: generatedLotNo
			};
		}));
		
		// 3. 상태 업데이트
		if (newLotList.length > 0) {
			setPRD3012_R01LotList(newLotList);
		}

		return newLotList;
	}, [setPRD3012_R01LotList, deletedPRD3012_R01LotList]);
	
	const handleSaveClick = useCallback(async () => {
		setLoadingSpinner(true);
		let valid = true;
		if(!validateInsertData(editPRD3012_R01!, PRD3012_R01LotList, PRD3012_R01DetailList, PRD3012_R01InspectList)) valid = false;
		if(!valid) { setLoadingSpinner(false); return; }
		
		// STEP 0: 초기화 전에 LOT 번호 가져와서 WMS1020_R01LotMap의 각 row에 추가
		// ========================================
		const newLotList = await assignLotNoToLists(PRD3012_R01LotList);
		
		// STEP 1: 초기화 전에 미출력 라벨 데이터 추출 - 자동출력 옵션 체크
		// ========================================
		let unprintedLabelData: LabelPrintData[] = [];
		if(PRD3012_R01Filter.labelPrintAuto === 'Y') {
			const store = usePRD3012_R01Store.getState();
			unprintedLabelData = PRD3012_R01_extractUnprintedLabelData(
				store,
				deletedPRD3012_R01LotList
			);
		}

		let processName = '';
		let newHeaderList: PRD3012_R01HeaderDto[] = [];
		let newInspectList: PRD3012_R01InspectDto[] = [];
		let newDetailList: PRD3012_R01DetailDto[] = [];
		let responseData: PRD3012_R01Dto = {
			productOrderHeaderDto: editPRD3012_R01!,
			productResultHeaderDto: getProductResultHeaderDto(editPRD3012_R01!),
			wmsStockLotDtoList: newLotList,
			bomDtoList: PRD3012_R01DetailList,
			prdInspectResultDtoList: PRD3012_R01InspectList,
		};
		let deleteHeaderFlag = false;

		try {
			
		
			if (editPRD3012_R01) {

				if (newLotList.length === 0) {
					processName = 'delete';
					const deleteResponse = await deletePRD3012_R01(editPRD3012_R01.productOrderNo);

					newHeaderList = PRD3012_R01List.filter(value => value.productOrderNo !== editPRD3012_R01.productOrderNo);

					if (deleteResponse && deleteResponse.data) {
						if (deleteResponse.data.successFlag) {
							showSuccess('생산실적 삭제가 성공하였습니다.');
							setMessage('생산실적 삭제가 성공하였습니다.');
						}else return;
					}
				} else {
					processName = 'patch';

					const deletedPRD3012_R01InspectList_Number = deletedPRD3012_R01InspectList.map(value => Number(value));
					const patchResponse = await patchPRD3012_R01({
						productOrderHeaderDto: editPRD3012_R01!,
						productResultHeaderDto: getProductResultHeaderDto(editPRD3012_R01!),
						wmsStockLotDtoList: newLotList.filter(value => (
							(value.lotQty > 0 && value.inserted === true)
						)),
						bomDtoList: PRD3012_R01DetailList,
						prdInspectResultDtoList: PRD3012_R01InspectList.filter(value => (
								!deletedPRD3012_R01InspectList_Number.includes(value.valueIndex) 
								&& validateString(value.badCase)
							)
						),
					});

					responseData = patchResponse.data.data;
					

					const responseproductOrderHeaderDto = {
						...responseData.productOrderHeaderDto,
						resultQty: responseData.productOrderHeaderDto.resultQty,
						orderQty: responseData.productOrderHeaderDto.orderQty - responseData.productOrderHeaderDto.resultQty
					};

					newHeaderList = PRD3012_R01List.map(value => {
						if (value.productOrderNo === responseData.productOrderHeaderDto.productOrderNo) {
							return responseproductOrderHeaderDto;
						}
						return value;
					});
					//생산양품량이 작업지시량이랑 같거나 크면, 해당 header을 list에서 삭제
					if (editPRD3012_R01!.productQty >= editPRD3012_R01!.orderQty) {
						newHeaderList = PRD3012_R01List.filter(value => value.productOrderNo !== responseData.productOrderHeaderDto.productOrderNo);	
						deleteHeaderFlag = true;
					}
					
					if (patchResponse?.data?.data && patchResponse.data.successFlag) {

						showSuccess('생산실적이 수정되었습니다.');
						setMessage('생산실적이 수정되었습니다.');
					}else {
						// 서버 응답이 예상과 다를 경우의 에러 처리
						showWarning('생산실적 수정 후 서버로부터 올바른 데이터를 받지 못했습니다.');
						return;
					}
				}
			} else {
				processName = 'post';
				const postResponse = await postPRD3012_R01({
					productOrderHeaderDto: editPRD3012_R01!,
					productResultHeaderDto: getProductResultHeaderDto(editPRD3012_R01!),
					wmsStockLotDtoList: newLotList,
					bomDtoList: PRD3012_R01DetailList,
					prdInspectResultDtoList: PRD3012_R01InspectList.filter(value => (
						validateString(value.badCase)
					)),
				});
				responseData = postResponse.data.data;

				const responseproductOrderHeaderDto = {
					...responseData.productOrderHeaderDto,
					resultQty: responseData.productResultHeaderDto.productQty
				};

				newHeaderList = [
					...PRD3012_R01List,
					responseproductOrderHeaderDto,
				] as PRD3012_R01HeaderDto[];
				
				if (postResponse?.data?.data && postResponse.data.successFlag) {
					showSuccess('생산실적이 등록되었습니다.');
					setMessage('생산실적이 등록되었습니다.');
				}else {
					// 서버 응답이 예상과 다를 경우의 에러 처리
					showWarning('생산실적 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			}
		} catch (error) {
			console.error("생산실적 작업 중 오류가 발생했습니다.:", error);
			// showError('생산실적 작업 중 오류가 발생했습니다.');
			setLoadingSpinner(false);
			return;
		}


		if (processName === 'delete' || deleteHeaderFlag) {
			setPRD3012_R01List(newHeaderList);

			// setSelectedPRD3012_R01(undefined);
			setEditPRD3012_R01({ ...defaultPRD3012_R01HeaderDto, })
			setPRD3012_R01DetailList([]);
			setPRD3012_R01LotList([]);

			setSelectedPRD3012_R01DetailList([]);
			setSelectedPRD3012_R01LotList([]);

			setOriginalPRD3012_R01DetailList([]);
			setOriginalPRD3012_R01LotList([]);

			setDeletedPRD3012_R01DetailList([]);
			setDeletedPRD3012_R01LotList([]);

			deleteHeaderFlag = false;

			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setPRD3012_R01List(newHeaderList);
			if (processName === 'post') {
				initPRD3012_R01LotData();
			} else {
				setPRD3012_R01LotList([]);
				insertPRD3012_R01LotList([defaultPRD3012_R01LotRow()]);
			}

			//응답 성공했을때의 데이터의 productOrderHeaderDto는 빈곳이 많으므로, 보간해야함
			const newEditPRD3012_R01 = {
				...responseData.productOrderHeaderDto,
				orderQty: responseData.productOrderHeaderDto.orderQty - responseData.productOrderHeaderDto.resultQty,
				itemStatus: responseData.productResultHeaderDto.itemStatus || itemStatusList[0]?.minorCd || '',
				productDt: responseData.productResultHeaderDto.productDt || formatDate(new Date()),
				logicCenter: responseData.productResultHeaderDto.logicCenter || '',
				warehouseCd: responseData.productResultHeaderDto.warehouseCd || '',
				outWarehouseCd: responseData.productResultHeaderDto.outWarehouseCd || '',
				badWarehouseCd: responseData.productResultHeaderDto.badWarehouseCd || '',
				productQty: 0,
				badQty: 0,
			};

			setEditPRD3012_R01({
				...newEditPRD3012_R01,
				workStartDt: editPRD3012_R01?.workStartDt,
				workEndDt: editPRD3012_R01?.workEndDt,
				productResultNo: responseData.productResultHeaderDto.productResultNo || editPRD3012_R01?.productResultNo || '',
			});
			if (processName === 'patch') {
				setOriginalPRD3012_R01LotList(responseData.wmsStockLotDtoList);
			}
			
			//기존 bomDetailList에서 responseData.bomDtoList에 존재하는 lotno, itemno인 행만 가져옴
			//  responseData.bomDtoList를 적용
			const newDetailList = PRD3012_R01DetailList.filter(
				value => responseData.bomDtoList.some(response => 
					response.childItemcd === value.childItemcd
					&& response.itemNo === value.itemNo
					&& response.lotNo === value.lotNo
				)
			).map(value => ({ 
				...value, 
				...responseData.bomDtoList.find(response => 
					response.childItemcd === value.childItemcd
					&& response.itemNo === value.itemNo
					&& response.lotNo === value.lotNo
				),
				childItemUsage: value.childItemUsage, 
				bomUsingQty: 0, 
				transportQty: 0, 
				isModified: false,
			}));
			setPRD3012_R01DetailList(newDetailList);
			setOriginalPRD3012_R01DetailList(newDetailList);
		}

		// setSelectedPRD3012_R01(undefined);
		setDeletedPRD3012_R01LotList([]);
		setSelectedPRD3012_R01LotList([]); // 저장 후 상세행 선택 상태 초기화
		setSelectedPRD3012_R01DetailList([]);
		
		setPRD3012_R01InspectList([defaultPRD3012_R01InspectRow()]);
		setSelectedPRD3012_R01InspectList([]);
		setDeletedPRD3012_R01InspectList([]);
		setOriginalPRD3012_R01InspectList([]);

		setTimeout(() => {
			setMessage('');
		}, 5000)
		setLoadingSpinner(false);
	
		// ========================================
		// STEP FINAL: 미출력 라벨 일괄 출력 (한 번에)
		// ========================================
		if (
			PRD3012_R01Filter.labelPrintAuto === 'Y'
			&& unprintedLabelData.length > 0 && processName !== 'delete'
		) {
			try {
				await printBulkLabel(unprintedLabelData);
				showSuccess(`저장 완료! ${unprintedLabelData.length}개 라벨 출력`);
			} catch (error: any) {
				console.error('라벨 출력 실패:', error);
				showWarning(`저장은 완료되었으나 라벨 출력에 실패했습니다: ${error?.message || '알 수 없는 오류'}`);
			}
		}
	}, [
		PRD3012_R01Filter.labelPrintAuto,
		editPRD3012_R01,
		// selectedPRD3012_R01, 
		printBulkLabel,
		PRD3012_R01LotList,
		PRD3012_R01DetailList,
		PRD3012_R01InspectList, deletedPRD3012_R01InspectList,
		PRD3012_R01List, setPRD3012_R01List
	]);

	const getServerMessage = useCallback((error: unknown) => {
		const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
		return serverMessage || '작업종료등록 중 오류가 발생했습니다.';
	}, []);	

	const handleWorkTimeClick = useCallback(async (productOrderNo: string, processType: PRD3012_R01WorkTimeProcessType, manualTime?: Date, rawTime?: { month: string, day: string, hour: string, minute: string }) => {
		const latestEdit = usePRD3012_R01Store.getState().editPRD3012_R01 ?? editPRD3012_R01;
		const isReset = processType === 'workStartReset' || processType === 'workEndReset';
		const isStart = processType === 'workStart' || processType === 'workStartReset';
		const modalType = isStart ? 'start' : 'end';

		// 작업지시번호가 없으면 모달만 열고 시·분은 브라우저 현재시간으로 채움
		if (!validateString(productOrderNo)) {
			if (isReset || manualTime || rawTime) {
				showWarning('작업지시 번호를 입력하세요.');
				return false;
			}
			setWorkTimeModalType(modalType);
			setWorkTimeModalVisible(true);
			return false;
		}

		if (!isReset && rawTime) {
			const m = Number(rawTime.month);
			const d = Number(rawTime.day);
			const h = Number(rawTime.hour);
			const min = Number(rawTime.minute);

			if (isNaN(m) || m < 1 || m > 12) { showWarning('월은 1~12월 사이로 입력해주세요.'); return false; }
			if (isNaN(d) || d < 1 || d > 31) { showWarning('일은 1~31일 사이로 입력해주세요.'); return false; }
			if (isNaN(h) || h < 0 || h > 23) { showWarning('시는 0~23 사이로 입력해주세요.'); return false; }
			if (isNaN(min) || min < 0 || min > 59) { showWarning('분은 0~59분 사이로 입력해주세요.'); return false; }
		}

		const timeField: 'workStartDt' | 'workEndDt' = isStart ? 'workStartDt' : 'workEndDt';
		const successMsg = isReset
			? (isStart ? '작업시작 초기화에 성공하였습니다.' : '작업종료 초기화에 성공하였습니다.')
			: (isStart ? '작업시작에 성공하였습니다.' : '작업종료에 성공하였습니다.');
		const failMsg = isReset
			? (isStart ? '작업시작 초기화에 실패하였습니다.' : '작업종료 초기화에 실패하였습니다.')
			: (isStart ? '작업시작에 실패하였습니다.' : '작업종료에 실패하였습니다.');

		let targetTime: Date;
		if (isReset) {
			// 초기화는 UTC 기준 Date로 생성해 JSON 직렬화 시 1900-01-01T00:00:00.000Z로 전송합니다.
			targetTime = new Date(defaultWorkTimeResetDate);
		} else if (manualTime) {
			targetTime = manualTime;
		} else {
			//시간이 없으면 현재시간 + 9시간으로 설정
			targetTime = new Date();
			// targetTime.setHours(targetTime.getHours() + 9);
			const isNewProductResultSession = isStart && !validateString(latestEdit?.productResultNo ?? '');
			// 작업종료는 항상 모달에서 시간 입력 후 전송 / 작업시작은 신규실적·기존시각 수정 시 모달
			const needsWorkTimeModal = !isStart
				|| isNewProductResultSession
				|| !isUnsetWorkDateTime(latestEdit?.[timeField]);
			if (needsWorkTimeModal) {
				setWorkTimeModalType(modalType);
				setWorkTimeModalVisible(true);
				return false;
			}
		}

		// 작업시작 < 작업종료 제약 (둘 중 하나라도 초기값이면 건너뜀)
		// 모달 확인 시 targetTime은 전송용(+9h)이므로, 비교는 화면 입력(rawTime) 또는 -9h 보정 시각 사용
		if (!isReset) {
			const toWallClockForCompare = (time: Date): Date => {
				const wall = new Date(time);
				// wall.setHours(wall.getHours() - 9);
				return wall;
			};

			let compareStartDt: Date | string | undefined;
			let compareEndDt: Date | string | undefined;

			if (rawTime) {
				const year = new Date().getFullYear();
				const wallClock = new Date(
					year,
					Number(rawTime.month) - 1,
					Number(rawTime.day),
					Number(rawTime.hour),
					Number(rawTime.minute),
				);
				if (isStart) {
					compareStartDt = wallClock;
					compareEndDt = latestEdit?.workEndDt;
				} else {
					compareStartDt = latestEdit?.workStartDt;
					compareEndDt = wallClock;
				}
			} else {
				const wallTarget = toWallClockForCompare(targetTime);
				compareStartDt = isStart ? wallTarget : latestEdit?.workStartDt;
				compareEndDt = isStart ? latestEdit?.workEndDt : wallTarget;
			}

			const isStartInitial = isUnsetWorkDateTime(compareStartDt);
			const isEndInitial = isUnsetWorkDateTime(compareEndDt);

			if (!isStartInitial && !isEndInitial) {
				const startMs = new Date(compareStartDt!).getTime();
				const endMs = new Date(compareEndDt!).getTime();
				if (startMs >= endMs) {
					showWarning('작업시작시간은 작업종료시간보다 빨라야 합니다.');
					return false;
				}
			}
		}

		try {
			if (!latestEdit) {
				showWarning('작업지시 정보가 없습니다.');
				return false;
			}
			if (!isStart && !isReset && !validateString(latestEdit.productResultNo)) {
				showWarning('생산실적코드를 입력하세요.');
				return false;
			}

			// 최초 작업시작(생산실적코드 없음)과 기존 실적의 시간 수정을 구분
			const hadProductResultNoBefore = validateString(latestEdit.productResultNo);
			const resolvedProductDt = resolvePRD3012_R01ProductDt(latestEdit);

			const headerWithWorkTime: PRD3012_R01HeaderDto = isStart
				? {
					...latestEdit,
					productDt: resolvedProductDt,
					// 최초 실적 생성 시 백엔드가 orderDt로 productDt를 설정함
					...(!hadProductResultNoBefore ? { orderDt: resolvedProductDt } : {}),
					workStartDt: toLocalDateTime(targetTime),
				}
				: {
					...latestEdit,
					workEndDt: toLocalDateTime(targetTime),
				};

			const postResponse = await postPRD3012_R01({
				productOrderHeaderDto: headerWithWorkTime,
				productResultHeaderDto: getProductResultHeaderDto(headerWithWorkTime),
				wmsStockLotDtoList: PRD3012_R01LotList,
				bomDtoList: PRD3012_R01DetailList,
				prdInspectResultDtoList: PRD3012_R01InspectList.filter(value => (
					validateString(value.badCase)
				)),
			});
			const responseData = postResponse.data;

			if(responseData && responseData.successFlag) {
				showSuccess(successMsg);
				setMessage(successMsg);

				const dto = responseData.data as PRD3012_R01Dto;
				const orderHeader = dto?.productOrderHeaderDto;
				const resultHeader = dto?.productResultHeaderDto;

				if (!isStart) {
					await resetToWorkOrderInitialState();
					return true;
				}

				const nextFrom = orderHeader?.workStartDt ?? resultHeader?.workStartDt ?? toLocalDateTime(targetTime);
				const resultProductResultNo = resultHeader?.productResultNo ?? '';
				const orderProductResultNo = orderHeader?.productResultNo ?? '';
				const nextProductResultNo = validateString(resultProductResultNo)
					? resultProductResultNo
					: validateString(orderProductResultNo)
					? orderProductResultNo
					: latestEdit.productResultNo;
				if (validateString(nextProductResultNo)) {
					setNotProductResult(false);
				}
				const nextProductDt = resolvePRD3012_R01ProductDt(
					resultHeader ?? latestEdit,
					resolvedProductDt,
				);
				// 최초 작업시작으로 생산실적이 생성된 경우에만 LOT/입력 생산량 초기화
				if (!hadProductResultNoBefore) {
					initPRD3012_R01LotData();
				}
				const editAfterInit = usePRD3012_R01Store.getState().editPRD3012_R01;
				if (editAfterInit) {
					const resetWorkEndDt = new Date(defaultWorkTimeResetDate);
					setEditPRD3012_R01({
						...editAfterInit,
						workStartDt: nextFrom,
						workEndDt: !hadProductResultNoBefore
							? toLocalDateTime(resetWorkEndDt)
							: (orderHeader?.workEndDt ?? resultHeader?.workEndDt ?? editAfterInit.workEndDt),
						productResultNo: nextProductResultNo,
						productDt: nextProductDt,
						// ResultInfo 작업자 — productResultHeaderDto 기준 반영
						productEmp: resultHeader?.productEmp || editAfterInit.productEmp || editAfterInit.orderEmp || '',
						productEmpNm: resultHeader?.productEmpNm || editAfterInit.productEmpNm || editAfterInit.orderEmpNm || '',
						jobTeam: resultHeader?.jobTeam || editAfterInit.jobTeam || '',
					});
				}
				return true;
			}else {
				showWarning(failMsg);
				return false;
			}
		} catch (error) {
			console.error(`${isStart ? '작업시작' : '작업종료'}등록 중 오류가 발생했습니다.:`, error);
			showError(getServerMessage(error));
			return false;
		}
	}, [editPRD3012_R01, PRD3012_R01LotList, PRD3012_R01DetailList, PRD3012_R01InspectList, initPRD3012_R01LotData, resetToWorkOrderInitialState, setNotProductResult]);

	//헤더의 정보를 받아서 기본값이 null이 아닌 빈 문자열 값을 찾아서 시스템코드의 기본값으로 표시되게 하기
	const handleProductResultInfoCode = useCallback((headerData: PRD3012_R01HeaderDto): Partial<PRD3012_R01HeaderDto> => {
		const defaults: Partial<PRD3012_R01HeaderDto> = {};

		defaults.productDt = resolvePRD3012_R01ProductDt(headerData);
				
		if(!validateString(headerData.compCd) && compCdList.length > 0)				defaults.compCd = compCdList[0].compCd;
		if(!validateString(headerData.workplaceCd) && workPlaceList.length > 0)		defaults.workplaceCd = workPlaceList[0].workplaceCd;

		if(!validateString(headerData.logicCenter) && wmsCdList.length > 0)			{
			defaults.logicCenter = wmsCdList[0].minorCd;
		}		
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;


		let warehouseListToUse = warehouseCdList.filter(value => (value.logicCenter === defaults.logicCenter
			&& (value.materialYn === 'Y' || value.goodsYn === 'Y' || value.productYn === 'Y' )
		));
		if(!validateString(headerData.warehouseCd) && warehouseListToUse.length > 0)	{
			defaults.warehouseCd = warehouseListToUse[0].warehouseCd;
		}

		defaults.itemStatus = validateString(headerData.itemStatus) ? headerData.itemStatus : (itemStatusList[0]?.minorCd ?? '');

		defaults.orderEmp = headerData.orderEmp ? headerData.orderEmp : (employeeCdList[0]?.empNo ?? '');
		defaults.orderEmpNm = headerData.orderEmpNm ? headerData.orderEmpNm : (employeeCdList[0]?.empNm ?? '');

		defaults.badQty = headerData.badQty ? headerData.badQty : 0;
	
		return defaults;
	}, [compCdList, workPlaceList, employeeCdList, wmsCdList, warehouseCdList, itemStatusList])

	const handleFetchBomProductList = useCallback(async ( itemCd: string, outWarehouseCd: string, logicCenter: string ) => {
		const productOrderNo = usePRD3012_R01Store.getState().editPRD3012_R01?.productOrderNo || '';
		const responseData = (await getPRD3012_R01DetailStockList(productOrderNo, itemCd, outWarehouseCd, logicCenter)).data.data;
		if(responseData && responseData.length > 0){

			//PRD3012_R01DetailList와 responseData를 비교해서
			//lotNo, childItemcd(itemCd)가 같으면 warehouseCd, logicCenter, lotQty를 업데이트
			const currentDetailList = usePRD3012_R01Store.getState().PRD3012_R01DetailList;
			const updatedDetails = currentDetailList.map((value) => {
				const response = responseData.find(response => 
					response.lotNo === value.lotNo && response.childItemcd === value.childItemcd
				);
				return {
					...value,
					logicCenter: value.logicCenter === logicCenter ? logicCenter : wmsCdList[0].minorCd,
					lotQty: response ? response.lotQty : 0,
				}
			});

			setPRD3012_R01DetailList(updatedDetails);
		}
		setOriginalPRD3012_R01DetailList(responseData);
		detailGridRef.current?.api.ensureIndexVisible(0, 'top');
		setMessage(`상세내역 ${responseData.length}건을 조회하였습니다.`);
		setTimeout(() => setMessage(""), 5000);


	}, [editPRD3012_R01?.itemCd, editPRD3012_R01?.warehouseCd, editPRD3012_R01?.logicCenter])


	
	// input form 팝업 열기 이벤트 핸들러
	const { getFieldHandlers: getProductWorkFieldHandlers } = useInfoFormEvents({
		editData: editPRD3012_R01,
		setEditData: setEditPRD3012_R01,
		defaultData: { ...defaultPRD3012_R01HeaderDto, inserted: true },
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD3012_R01'
	});

	//생산실적코드 기준 생산결과 조회
	const fetchProductResult = useCallback(async (headerData: PRD3012_R01HeaderDto) => {
		let apiHeaderData: PRD3012_R01ProductResultDto | null = null;
		try {
			const transportResponse = await getPRD3012_R01ProductResultList(headerData.productResultNo!);
			apiHeaderData = transportResponse.data.data;

			let baseDataForDefaults;
			if (apiHeaderData && apiHeaderData.productResultNo) {
				setNotProductResult(false);
				const preservedProductQty = headerData.productQty ?? 0;
				baseDataForDefaults = {
					...defaultPRD3012_R01HeaderDto,
					...headerData,
					...apiHeaderData,
					orderQty: headerData.orderQty,
					productQty: preservedProductQty,
					badQty: 0,
					itemStatus: apiHeaderData.itemStatus ? apiHeaderData.itemStatus : (itemStatusList[0]?.minorCd ?? ''),
				};
			} else {
				setNotProductResult(true);
				baseDataForDefaults = {
					...defaultPRD3012_R01HeaderDto,
					...headerData,
				};
			}

			const defaultValues = handleProductResultInfoCode(baseDataForDefaults);

			setEditPRD3012_R01({
				...baseDataForDefaults,
				...defaultValues,
			});
		} catch (error) {
			console.error("ProductResult 내역 조회 실패:", error);
			setNotProductResult(true);
		}

		if (apiHeaderData && apiHeaderData.productResultNo) {
			return apiHeaderData;
		}
		return null;
	}, [handleProductResultInfoCode, setEditPRD3012_R01, setNotProductResult, itemStatusList]);

	const fetchStockLotList = useCallback(async (productResultNo: string) => {
		try {
			const response = await getPRD3012_R01StockLot(productResultNo);
			const lotList = response.data.data ?? [];

			setDeletedPRD3012_R01LotList([]);
			setSelectedPRD3012_R01LotList([]);

			if (lotList.length > 0) {
				setPRD3012_R01LotList([]);
				insertPRD3012_R01LotList(lotList);
				setOriginalPRD3012_R01LotList(lotList);
			} else {
				initPRD3012_R01LotData();
			}
		} catch (error) {
			console.error('LOT 조회 실패:', error);
			initPRD3012_R01LotData();
		}
	}, [
		initPRD3012_R01LotData,
		insertPRD3012_R01LotList,
		setDeletedPRD3012_R01LotList,
		setPRD3012_R01LotList,
		setOriginalPRD3012_R01LotList,
		setSelectedPRD3012_R01LotList,
	]);

	const handleLotCreateClick = useCallback(async () => {
		if (!editPRD3012_R01) {
			showWarning('작업지시 정보가 없습니다.');
			return;
		}
		if (!validateString(editPRD3012_R01.productOrderNo)) {
			showWarning('작업지시 번호를 입력하세요.');
			return;
		}
		if (!validateString(editPRD3012_R01.productResultNo)) {
			showWarning('생산실적코드를 입력하세요.');
			return;
		}
		const pendingLotQty = editPRD3012_R01.pendingLotQty ?? 0;
		if (pendingLotQty <= 0) {
			showWarning('생산량을 입력해주세요.');
			return;
		}
		for (const detail of PRD3012_R01DetailList) {
			if (detail.transportQty > detail.lotQty) {
				showWarning(`${detail.childItemcd} 품목의 출고량은 재고량보다 클 수 없습니다.`);
				return;
			}
		}

		setLoadingSpinner(true);
		try {
			const lotNoRes = await createPRD3012_R01LotNo();
			const lotNo = lotNoRes.data?.successFlag ? lotNoRes.data.data : '';
			if (!lotNo) {
				showWarning('LOT 번호 발행에 실패하였습니다.');
				return;
			}

			const newLot: PRD3012_R01LotDto = {
				...defaultPRD3012_R01LotRow(),
				lotNo,
				lotQty: pendingLotQty,
				inserted: true,
			};

			const deletedPRD3012_R01InspectList_Number = deletedPRD3012_R01InspectList.map(value => Number(value));
			const stockLotResponse = await postPRD3012_R01StockLot({
				productOrderHeaderDto: editPRD3012_R01,
				productResultHeaderDto: {
					...getProductResultHeaderDto(editPRD3012_R01),
					badQty: editPRD3012_R01.badQty ?? 0,
				},
				wmsStockLotDtoList: [newLot],
				bomDtoList: PRD3012_R01DetailList,
				prdInspectResultDtoList: PRD3012_R01InspectList.filter(value => (
					!deletedPRD3012_R01InspectList_Number.includes(value.valueIndex)
					&& validateString(value.badCase)
				)),
			});

			if (!stockLotResponse.data?.successFlag || !stockLotResponse.data.data) {
				showWarning('LOT 발행 후 서버로부터 올바른 데이터를 받지 못했습니다.');
				return;
			}

			const responseData = stockLotResponse.data.data;
			const qtyUpdate = resolveQtyAfterLotIssue(
				editPRD3012_R01,
				responseData.productOrderHeaderDto,
				pendingLotQty,
			);
			const responseProductOrderHeaderDto = {
				...responseData.productOrderHeaderDto,
				...qtyUpdate,
			};

			setPRD3012_R01List(PRD3012_R01List.map(value => (
				value.productOrderNo === responseData.productOrderHeaderDto.productOrderNo
					? responseProductOrderHeaderDto
					: value
			)));

			setEditPRD3012_R01({
				...editPRD3012_R01,
				...responseData.productOrderHeaderDto,
				...qtyUpdate,
				itemStatus: responseData.productResultHeaderDto?.itemStatus || editPRD3012_R01.itemStatus || itemStatusList[0]?.minorCd || '',
				productResultNo: responseData.productResultHeaderDto?.productResultNo || editPRD3012_R01.productResultNo,
				pendingLotQty: 0,
				badQty: responseData.productResultHeaderDto?.badQty ?? editPRD3012_R01.badQty ?? 0,
				workStartDt: editPRD3012_R01.workStartDt,
				workEndDt: editPRD3012_R01.workEndDt,
			});

			await handleFetchProductResultRef.current?.();

			// 생산량(pendingLotQty) 0 초기화에 맞춰 출고량·소요량 자동계산만 재적용 (출고창고 등 기존 행 정보는 유지)
			const latestState = usePRD3012_R01Store.getState();
			setPRD3012_R01DetailList(
				recalculateDetailListWithTransport(
					latestState.PRD3012_R01DetailList,
					latestState.editPRD3012_R01,
				),
			);

			showSuccess('LOT 발행이 완료되었습니다.');
			setMessage('LOT 발행이 완료되었습니다.');
		} catch (error) {
			console.error('LOT 발행 중 오류가 발생했습니다.:', error);
			const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
			showWarning(serverMessage || 'LOT 번호 발행 중 오류가 발생하였습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [
		PRD3012_R01DetailList,
		PRD3012_R01InspectList,
		PRD3012_R01List,
		defaultPRD3012_R01LotRow,
		deletedPRD3012_R01InspectList,
		editPRD3012_R01,
		itemStatusList,
		setEditPRD3012_R01,
		setPRD3012_R01DetailList,
		setPRD3012_R01List,
		setLoadingSpinner,
		setMessage,
	]);

	const handleFetchProductResult = useCallback(async () => {
		if (isFetchingProductResultRef.current) return;
		isFetchingProductResultRef.current = true;

		try {
			const headerData = usePRD3012_R01Store.getState().editPRD3012_R01;
			if (!headerData || !validateString(headerData.productOrderNo)) {
				showWarning('작업지시 번호를 입력하세요.');
				return;
			}
			if (!validateString(headerData.productResultNo)) {
				showWarning('생산실적코드를 입력하세요.');
				return;
			}

			const preservedProductQty = headerData.productQty ?? 0;

			setPRD3012_R01LotList([]);
			setPRD3012_R01DetailList([]);
			setPRD3012_R01InspectList([]);

			const productResult = await fetchProductResult(headerData);
			const currentHeader = usePRD3012_R01Store.getState().editPRD3012_R01 ?? headerData;

			if (productResult && productResult.productResultNo !== '') {
				await fetchDetailList(
					productResult.itemCd || '',
					productResult.productQty ?? 0,
					productResult.badQty ?? 0,
					currentHeader.outWarehouseCd,
					currentHeader.logicCenter,
					currentHeader.workplaceCd,
				);
				await handleFetchBomProductList(
					productResult.itemCd,
					currentHeader.outWarehouseCd,
					productResult.logicCenter || currentHeader.logicCenter || wmsCdList[0].minorCd,
				);
				await fetchStockLotList(productResult.productResultNo);
				await refreshInspectListFromServer(productResult.productResultNo);
			} else {
				await fetchDetailList(
					currentHeader.itemCd || '',
					0,
					0,
					currentHeader.outWarehouseCd,
					currentHeader.logicCenter,
					currentHeader.workplaceCd,
				);
				initPRD3012_R01LotData();
				setDeletedPRD3012_R01InspectList([]);
				setSelectedPRD3012_R01InspectList([]);
				setOriginalPRD3012_R01InspectList([]);
				setPRD3012_R01InspectList([]);
				insertPRD3012_R01InspectList([defaultPRD3012_R01InspectRow()]);
			}

			const latestEdit = usePRD3012_R01Store.getState().editPRD3012_R01;
			if (latestEdit) {
				setEditPRD3012_R01({ ...latestEdit, pendingLotQty: 0, productQty: preservedProductQty });
			}
		} finally {
			isFetchingProductResultRef.current = false;
		}
	}, [
		fetchProductResult,
		fetchDetailList,
		fetchStockLotList,
		handleFetchBomProductList,
		initPRD3012_R01LotData,
		insertPRD3012_R01InspectList,
		defaultPRD3012_R01InspectRow,
		refreshInspectListFromServer,
		setDeletedPRD3012_R01InspectList,
		setEditPRD3012_R01,
		setPRD3012_R01LotList,
		setPRD3012_R01DetailList,
		setPRD3012_R01InspectList,
		setOriginalPRD3012_R01InspectList,
		setSelectedPRD3012_R01InspectList,
		wmsCdList,
	]);

	handleFetchProductResultRef.current = handleFetchProductResult;

	const handleFetchLotList = useCallback(async (productOrderNoArg?: string): Promise<boolean> => {
		const state = usePRD3012_R01Store.getState();
		// 행 선택 확정값(selected) 우선 — edit 클로저/미반영에 의존하지 않음
		const productOrderNo = productOrderNoArg
			|| state.selectedPRD3012_R01?.productOrderNo
			|| state.editPRD3012_R01?.productOrderNo
			|| '';

		if (!validateString(productOrderNo)) {
			showWarning('작업지시 번호를 입력하세요.');
			return false;
		}

		setPRD3012_R01LotList([]);
		setPRD3012_R01DetailList([]);
		setPRD3012_R01InspectList([]);
		setDeletedPRD3012_R01LotList([]);
		setSelectedPRD3012_R01LotList([]);
		setOriginalPRD3012_R01LotList([]);
		setDeletedPRD3012_R01InspectList([]);
		setSelectedPRD3012_R01InspectList([]);
		setOriginalPRD3012_R01InspectList([]);

		const headerData = await fetchOne(productOrderNo);
		if (!headerData) {
			return false;
		}

		await fetchDetailList(
			headerData.itemCd || '',
			0,
			0,
			headerData.outWarehouseCd,
			headerData.logicCenter,
			headerData.workplaceCd,
		);

		initPRD3012_R01LotData();
		setPRD3012_R01InspectList([]);
		insertPRD3012_R01InspectList([defaultPRD3012_R01InspectRow()]);

		// fetchOne에서 생산실적코드·작업시간 등을 초기화하므로 이전 실적코드로 재조회하지 않음
		return true;
	}, [
		defaultPRD3012_R01InspectRow,
		fetchDetailList,
		fetchOne,
		initPRD3012_R01LotData,
		insertPRD3012_R01InspectList,
		setDeletedPRD3012_R01InspectList,
		setDeletedPRD3012_R01LotList,
		setPRD3012_R01DetailList,
		setPRD3012_R01InspectList,
		setPRD3012_R01LotList,
		setOriginalPRD3012_R01InspectList,
		setOriginalPRD3012_R01LotList,
		setSelectedPRD3012_R01InspectList,
		setSelectedPRD3012_R01LotList,
	]);

	useEffect(() => {
		setPRD3012_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
	}, [defaultLabelPrintAuto, setPRD3012_R01Filter]);

	// 좌측 테이블 행 선택 / 조회 후 자동 선택
	const handleLoadSelectedDetail = useCallback(async () => {
		// selected가 스토어에 확정된 뒤에만 진입 (effect 가드와 동일 조건)
		const selected = usePRD3012_R01Store.getState().selectedPRD3012_R01;
		if (!selected) {
			setDetailFetchTrigger(false);
			return;
		}

		setDetailScrollTop(null);
		setLotScrollTop(null);
		setInspectScrollTop(null);

		setEditPRD3012_R01({
			...defaultPRD3012_R01HeaderRow(),
			...selected,
			orderQty: Math.max(0, Number(selected.orderQty) || 0),
		});

		if (validateString(selected.productResultNo)) {
			await handleFetchProductResultRef.current?.();
		} else if (validateString(selected.productOrderNo)) {
			await handleFetchLotList(selected.productOrderNo);
		}

		setDetailFetchTrigger(false);
	}, [
		defaultPRD3012_R01HeaderRow, setEditPRD3012_R01,
		setDetailFetchTrigger, setDetailScrollTop, setLotScrollTop, setInspectScrollTop,
		handleFetchLotList,
	]);

	useEffect(() => {
		// setSelected로 selected + detailFetchTrigger가 둘 다 잡힌 커밋 이후에만 상세 로드
		if (detailFetchTrigger && selectedPRD3012_R01?.productOrderNo) {
			void handleLoadSelectedDetail();
		}
	}, [detailFetchTrigger, selectedPRD3012_R01?.productOrderNo, handleLoadSelectedDetail]);
	
	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		fetchOne,
		defaultPRD3012_R01HeaderRow,
		defaultPRD3012_R01LotRow,
		defaultPRD3012_R01DetailRow,
		defaultPRD3012_R01InspectRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleWorkTimeClick,
		handleFetchBomProductList,
		getProductWorkFieldHandlers,
		handleFetchLotList,
		handleFetchProductResult,
		handleLotCreateClick,
		handleInspectConfirmClick,
		handleInspectDeleteClick,
	};
}
